<template>
  <el-pagination
    background
    :small="small"
    :layout="layout"
    :total="total"
    :page-size="pageSize"
    :page-sizes="pageSizes"
    :current-page="pageNum"
    :pager-count="pagerCount"
    @size-change="sizeChange"
    @current-change="currentChange"
  />
</template>
<script>
export default {
  name: 'PubPagination',
  components: {},
  props: {
    total: {
      type: Number,
      required: false,
      default: 0
    },
    pageNum: {
      type: Number,
      required: false,
      default: 1
    },
    pageSize: {
      type: Number,
      required: false,
      default: 10
    },
    pagerCount: {
      type: Number,
      required: false,
      default: 11
    },
    layout: {
      type: String,
      required: false,
      default: 'total, prev, pager, next, sizes'
    },
    small: {
      type: Boolean,
      required: false,
      default: false
    },
    pageSizes: {
      type: Array,
      required: false,
      default: () => {
        return [10, 20, 50, 100];
      }
    }
  },
  methods: {
    sizeChange(e) {
      this.$emit('size-change', e);
    },
    currentChange(e) {
      this.$emit('current-change', e);
    }
  }
};
</script>
